<script setup lang="ts">
import { useRouter } from 'vue-router'
import ErwinzillaLogo from '@/assets/images/erwinzilla.svg'

const router = useRouter()

const goHome = () => router.push({ name: 'home' })
</script>

<template>
  <div @click="goHome" class="cursor-pointer">
    <ErwinzillaLogo class="w-48 h-auto" />
  </div>
</template>

<style scoped></style>
